export default __webpack_public_path__ + "static/realWorldImg3-cd68767552cb9e50ef0d27d2ae10a46c.png";